export default "__VITE_ASSET__BBZerCz0__"